import React from 'react';
import './Footer.css';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';

const Footer = () => {
  return (
    <footer>
      <div className='footer__inner'>
        <a href='#top' className='footer__logo'>Felipe Alberto</a>
        <p className='footer__tag'>iOS Developer · GenAI Developer</p>

        <ul className='permalinks'>
          <li><a href='#top'>Home</a></li>
          <li><a href='#about'>About</a></li>
          <li><a href='#experience'>Stack</a></li>
          <li><a href='#journey'>Experience</a></li>
          <li><a href='#portfolio'>Projects</a></li>
          <li><a href='#contact'>Contact</a></li>
        </ul>

        <div className='footer__socials'>
          <a href='https://www.linkedin.com/in/felipe-alberto-8b01a2268/' target='_blank' rel='noreferrer' aria-label='LinkedIn'><BsLinkedin /></a>
          <a href='https://github.com/felipalb' target='_blank' rel='noreferrer' aria-label='GitHub'><FaGithub /></a>
          <a href='mailto:felipealbertosantos@outlook.com' aria-label='Email'><MdMailOutline /></a>
        </div>

        <div className="footer__copyright">
          <small>© {new Date().getFullYear()} Felipe Alberto</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
